function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V19C0.5 20.3807 1.61929 21.5 3 21.5H14C15.3807 21.5 16.5 20.3807 16.5 19V6.75621C16.5 6.14708 16.2776 5.5589 15.8746 5.10215L12.5603 1.34595C12.0857 0.808096 11.403 0.5 10.6857 0.5H3Z",
  stroke: "#696B6D",
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.232 18V14.402H4.14V13.506H5.232V12.358H4.14V11.462H5.232V8.004H6.688L8.018 11.462H9.67V8.004H10.776V11.462H11.868V12.358H10.776V13.506H11.868V14.402H10.776V18H9.306L7.976 14.402H6.324V18H5.232ZM6.296 11.462H6.884L6.296 9.726H6.24L6.296 11.462ZM6.324 13.506H7.64L7.22 12.358H6.296L6.324 13.506ZM8.76 13.506H9.698L9.67 12.358H8.34L8.76 13.506ZM9.67 16.026H9.726L9.684 14.402H9.096L9.67 16.026Z",
  fill: "#696B6D"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 1V6C11 6.55228 11.4477 7 12 7H16",
  stroke: "#696B6D",
  strokeMiterlimit: 10
});

var SvgQuote = function SvgQuote(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote.8b31e3d8.svg";
export { ForwardRef as ReactComponent };